import * as ng from 'angular';
import * as _ from 'underscore';
import * as Highcharts from 'highcharts';

import { Dataset } from '..';

ng.module('e360')
   .factory('barChartFactory', barChartFactory);

barChartFactory.$inject = ['instanceServiceFactory'];
function barChartFactory(instanceServiceFactory) {
   return instanceServiceFactory(BarChart);
}

// Requires that object data has a single series defined, could contain more than one
export class BarChart {
   protected chart:Highcharts.ChartObject;
   static $inject = ['ds'];
   constructor(protected ds:Dataset, extraOptions:any = null) {
      let options = {
         chart: {
            renderTo: ds.id,
            type: 'column'
         },
         title: {
            text: ds.title,
         },
         exporting: {
            filename: ds.id
         },
         yAxis: {
            min: 0
         },
         series: [{}]
      };

      if (extraOptions) {
         options = ng.merge(options, extraOptions);
      }

      this.chart = new Highcharts.Chart(options);
   }

   setData(data:any[]) {
      this.chart.series[0].setData(data);
   }

   onLoadStart() {
      this.chart.showLoading();
   }

   onLoadFinish() {
      this.chart.hideLoading();
   }
}

export interface BarChartFactory {
   ({ds:Dataset}):BarChart;
}
